<template>
  <div>
    <a class="btn btn-default" @click.prevent="showPopupData">ポップアップをプレビュー</a>
    <Transition>
      <PopupBackdrop v-if="showBackdrop" />
    </Transition>
    <Transition @after-leave="showNextPopup">
      <GeneralPopup
        v-if="generalPopupItem"
        :heading="generalPopupItem.title"
        :body-markdown="generalPopupItem.body"
        :image-url="generalPopupItem.image"
        :button-url="generalPopupItem.url"
        @close="onClose"
      />
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import PopupBackdrop from 'components/popup/PopupBackdrop.vue';
import GeneralPopup from 'containers/GeneralPopup.vue';
import type { PopupData } from 'oc2api/popup';

export default defineComponent({
  name: 'OCPopup',
  components: {
    PopupBackdrop,
    GeneralPopup,
  },
  props: {
    imageUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const showBackdrop = ref(false);
    const generalPopupItem = ref<PopupData['popup']['item']>();

    const showPopupData = () => {
      const title = (document.getElementById('my_notification_title') as HTMLInputElement).value;
      const body = (document.getElementById('my_notification_body') as HTMLInputElement).value;
      const url = (document.getElementById('my_notification_url') as HTMLInputElement).value;
      showBackdrop.value = true;
      generalPopupItem.value = {
        title: title,
        body: body,
        url: url,
        image: props.imageUrl,
      };
    };

    const onClose = async () => {
      showBackdrop.value = false;
      generalPopupItem.value = undefined;
    };

    return {
      showBackdrop,
      generalPopupItem,
      showPopupData,
      onClose,
    };
  },
});
</script>

<style lang="scss" scoped>
.v-enter {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
